import React from 'react';
import { motion } from 'framer-motion';
import { containerVariants, iconVariants, itemVariants } from '../signup/motion';
import { FiCheckCircle } from "react-icons/fi"
import { useNavigate } from "react-router-dom";

export default function Step4() {
  const navigate = useNavigate();
  return (
    <motion.div
      className="bg-white py-8 px-10 rounded-sm shadow-custom border border-[#2A3D66]/40 w-full max-w-xl text-center"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <motion.div
        className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
        variants={iconVariants}
      >
        <FiCheckCircle className="h-16 w-16 text-[#036494]" />
      </motion.div>

      <motion.h2 className="text-xl mb-6" variants={itemVariants}>
      Password Reset Successfully
      </motion.h2>

      <motion.div variants={itemVariants} whileHover={{ scale: 1.02 }} whileTap={{ scale: 0.98 }}>
        <button
          onClick={()=>navigate("/login")}
          className="w-full bg-[#036494] text-white py-2 rounded-full hover:bg-[#075985] transition-colors"
        >
          Log in
        </button>
      </motion.div>
    </motion.div>
  )
}


